module.exports = __webpack_public_path__ + "static/noticias-09-7ea66b44671a3043178a4244ad94e541.jpg";